// const lightestVal = val => ((255 - val) * 0.815 + val)
// const lightenVal = val => ((255 - val) * 0.27 + val)
// const darkenVal = val => val * 0.82

const colors = {
  primaryLightest: '#e5f8fe',
  primaryLight: '#45c3f3',
  primary: '#00adef',
  primaryDark: '#008ec4',
  secondaryLightest: '#dddef9',
  secondaryLight: '#777be7',
  secondary: '#454ade',
  secondaryDark: '#393db6',
  tertiaryLightest: '#d2f2f2',
  tertiaryLight: '#4ecdcd',
  tertiary: '#0cbaba',
  tertiaryDark: '#0a9999',
  success: '#0cbaba',
  error: '#ff4242',
  neutralLightest: '#f4f4f4',
  neutralLight: '#dfdfdf',
  neutral: '#b4b4b6',
  neutralDark: '#8a8a8d',
  neutralDarkest: '#505050',
  placeholder: '#8a8a8d',
  white: '#ffffff'
}

window.colors = colors

export {colors as default}


// WEBPACK FOOTER //
// ./assets/common/theme/colors.js